/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  CpiStockDto,
  GetCatalogProductsV1Params,
  GetCatalogRelatedProductsForBagV1Params,
  GetCatalogRelatedProductsV1Params,
  GetCatalogSearchSuggestionsV1Params,
  GetStocksV1Params,
  ProductDetailDto,
  ProductListItemDto,
  ProductSearchResultDto,
  ResolveShippingRatesV1Params,
  SearchSuggestionsDto,
  ShippingProfileDto,
  ShippingResolveResultDto
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getCatalogProductsV1Response200 = {
  data: ProductSearchResultDto
  status: 200
}

export type getCatalogProductsV1Response500 = {
  data: void
  status: 500
}

export type getCatalogProductsV1ResponseSuccess = (getCatalogProductsV1Response200) & {
  headers: Headers;
};
export type getCatalogProductsV1ResponseError = (getCatalogProductsV1Response500) & {
  headers: Headers;
};

export type getCatalogProductsV1Response = (getCatalogProductsV1ResponseSuccess | getCatalogProductsV1ResponseError)

export const getGetCatalogProductsV1Url = (params?: GetCatalogProductsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["section","category","subcategory","subsubcategory","brand","collection","slugs"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/catalog/products?${stringifiedParams}` : `/api/v1/catalog/products`
}

/**
 * Returns a paginated list of active products from the local catalogue, plus the
 * available filter facets (brands, colors, price range across the full scope, and a
 * hierarchical category drill-down) for the current search.
 *
 * Filters (multi-value, repeat parameter per value):
 * - section: filter by gender/section slug
 * - category: filter by category slug
 * - subcategory: filter by subcategory slug
 * - subsubcategory: filter by subsubcategory slug
 * - brand: filter by vendor/brand name
 * - collection: filter by collection Umbraco node key (GUID)
 * - slugs: filter by any ProductTag slug (e.g. "color_red", "gender_women")
 * - q: free text matched against product title or brand (single value)
 * - priceMin / priceMax: filter to products with at least one variant priced in range
 * - sortBy: TitleAsc, TitleDesc, PriceAsc, PriceDesc, Newest, Oldest, CollectionOrder.
 *   Omitted defaults to TitleAsc — except when exactly one collection is selected, in
 *   which case it defaults to CollectionOrder (Shopify's manual per-collection product
 *   order). CollectionOrder falls back to TitleAsc when 0 or 2+ collections are selected.
 *
 * Category drill-down: only one of Categories/Subcategories/SubSubcategories is
 * populated in the response, depending on the deepest category filter applied —
 * Categories when none/only a collection is selected, Subcategories once a category is
 * selected, SubSubcategories once a subcategory is selected.
 * @summary Browse products
 */
export const getCatalogProductsV1 = async (params?: GetCatalogProductsV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getCatalogProductsV1Response> => {

  return customFetch<getCatalogProductsV1Response>(getGetCatalogProductsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getCatalogProductByGuidV1Response200 = {
  data: ProductDetailDto
  status: 200
}

export type getCatalogProductByGuidV1Response404 = {
  data: void
  status: 404
}

export type getCatalogProductByGuidV1Response500 = {
  data: void
  status: 500
}

export type getCatalogProductByGuidV1ResponseSuccess = (getCatalogProductByGuidV1Response200) & {
  headers: Headers;
};
export type getCatalogProductByGuidV1ResponseError = (getCatalogProductByGuidV1Response404 | getCatalogProductByGuidV1Response500) & {
  headers: Headers;
};

export type getCatalogProductByGuidV1Response = (getCatalogProductByGuidV1ResponseSuccess | getCatalogProductByGuidV1ResponseError)

export const getGetCatalogProductByGuidV1Url = (publicGuid: string,) => {




  return `/api/v1/catalog/products/${publicGuid}`
}

/**
 * Returns full product detail — images and variants — for the given product public GUID.
 * @summary Get product detail
 */
export const getCatalogProductByGuidV1 = async (publicGuid: string, options?: Parameters<typeof customFetch>[1]): Promise<getCatalogProductByGuidV1Response> => {

  return customFetch<getCatalogProductByGuidV1Response>(getGetCatalogProductByGuidV1Url(publicGuid),
  {
    ...options,
    method: 'GET'


  }
);}


export type getCatalogRelatedProductsV1Response200 = {
  data: ProductListItemDto[]
  status: 200
}

export type getCatalogRelatedProductsV1Response404 = {
  data: void
  status: 404
}

export type getCatalogRelatedProductsV1Response500 = {
  data: void
  status: 500
}

export type getCatalogRelatedProductsV1ResponseSuccess = (getCatalogRelatedProductsV1Response200) & {
  headers: Headers;
};
export type getCatalogRelatedProductsV1ResponseError = (getCatalogRelatedProductsV1Response404 | getCatalogRelatedProductsV1Response500) & {
  headers: Headers;
};

export type getCatalogRelatedProductsV1Response = (getCatalogRelatedProductsV1ResponseSuccess | getCatalogRelatedProductsV1ResponseError)

export const getGetCatalogRelatedProductsV1Url = (publicGuid: string,
    params: GetCatalogRelatedProductsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/catalog/products/${publicGuid}/related?${stringifiedParams}` : `/api/v1/catalog/products/${publicGuid}/related`
}

/**
 * Returns active products related to the given product: same category, same gender, and
 * tagged "New" in Shopify — most recent first, excluding the product itself. No fallback:
 * if the source product has no category/gender tag, or nothing matches, the list is
 * simply empty (never an error). Returns 404 when the source product does not exist.
 *
 * Parameters:
 * - limit: maximum number of products to return (default 6, capped at 20)
 * @summary Get related products
 */
export const getCatalogRelatedProductsV1 = async (publicGuid: string,
    params: GetCatalogRelatedProductsV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getCatalogRelatedProductsV1Response> => {

  return customFetch<getCatalogRelatedProductsV1Response>(getGetCatalogRelatedProductsV1Url(publicGuid,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getCatalogRelatedProductsForBagV1Response200 = {
  data: ProductListItemDto[]
  status: 200
}

export type getCatalogRelatedProductsForBagV1Response404 = {
  data: void
  status: 404
}

export type getCatalogRelatedProductsForBagV1Response500 = {
  data: void
  status: 500
}

export type getCatalogRelatedProductsForBagV1ResponseSuccess = (getCatalogRelatedProductsForBagV1Response200) & {
  headers: Headers;
};
export type getCatalogRelatedProductsForBagV1ResponseError = (getCatalogRelatedProductsForBagV1Response404 | getCatalogRelatedProductsForBagV1Response500) & {
  headers: Headers;
};

export type getCatalogRelatedProductsForBagV1Response = (getCatalogRelatedProductsForBagV1ResponseSuccess | getCatalogRelatedProductsForBagV1ResponseError)

export const getGetCatalogRelatedProductsForBagV1Url = (publicGuid: string,
    params: GetCatalogRelatedProductsForBagV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/catalog/products/${publicGuid}/related-purchase?${stringifiedParams}` : `/api/v1/catalog/products/${publicGuid}/related-purchase`
}

/**
 * Returns active products related to the given product for the "add to bag" placement:
 * same brand and same gender, preferring products tagged "New" in Shopify — most recent
 * first, excluding the product itself. If no "New"-tagged match exists, falls back to the
 * most recent same-brand+gender products regardless of the "New" tag. No fallback if the
 * source product has no brand/gender tag — the list is simply empty (never an error).
 * Returns 404 when the source product does not exist.
 *
 * Parameters:
 * - limit: maximum number of products to return (default 6, capped at 20)
 * @summary Get related products for add-to-bag
 */
export const getCatalogRelatedProductsForBagV1 = async (publicGuid: string,
    params: GetCatalogRelatedProductsForBagV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getCatalogRelatedProductsForBagV1Response> => {

  return customFetch<getCatalogRelatedProductsForBagV1Response>(getGetCatalogRelatedProductsForBagV1Url(publicGuid,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getCatalogSearchSuggestionsV1Response200 = {
  data: SearchSuggestionsDto
  status: 200
}

export type getCatalogSearchSuggestionsV1Response400 = {
  data: void
  status: 400
}

export type getCatalogSearchSuggestionsV1Response500 = {
  data: void
  status: 500
}

export type getCatalogSearchSuggestionsV1ResponseSuccess = (getCatalogSearchSuggestionsV1Response200) & {
  headers: Headers;
};
export type getCatalogSearchSuggestionsV1ResponseError = (getCatalogSearchSuggestionsV1Response400 | getCatalogSearchSuggestionsV1Response500) & {
  headers: Headers;
};

export type getCatalogSearchSuggestionsV1Response = (getCatalogSearchSuggestionsV1ResponseSuccess | getCatalogSearchSuggestionsV1ResponseError)

export const getGetCatalogSearchSuggestionsV1Url = (params: GetCatalogSearchSuggestionsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/catalog/search?${stringifiedParams}` : `/api/v1/catalog/search`
}

/**
 * Free-text search over the catalogue, optionally scoped to a section. Returns the top 10
 * of each: products (matched on title or brand, with public GUIDs; title localized to
 * Accept-Language when a translation exists), category, subcategory and subsubcategory
 * (Name localized to Accept-Language when an editor has translated it in Umbraco — the
 * Slug itself is always the untranslated ProductTag slug, still usable directly as a
 * /products filter), and collections (matched on title, localized to Accept-Language
 * when a translation exists, with the Umbraco node key GUID accepted by the /products
 * "collection" filter). Taxonomy and collections are ranked by how many active products
 * in scope carry them.
 *
 * Parameters:
 * - q: free text to search for (required)
 * - section: section slug (e.g. "gender_men") to scope all results to (optional)
 * @summary Search suggestions
 */
export const getCatalogSearchSuggestionsV1 = async (params: GetCatalogSearchSuggestionsV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getCatalogSearchSuggestionsV1Response> => {

  return customFetch<getCatalogSearchSuggestionsV1Response>(getGetCatalogSearchSuggestionsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getShippingProfilesV1Response200 = {
  data: ShippingProfileDto[]
  status: 200
}

export type getShippingProfilesV1Response500 = {
  data: void
  status: 500
}

export type getShippingProfilesV1ResponseSuccess = (getShippingProfilesV1Response200) & {
  headers: Headers;
};
export type getShippingProfilesV1ResponseError = (getShippingProfilesV1Response500) & {
  headers: Headers;
};

export type getShippingProfilesV1Response = (getShippingProfilesV1ResponseSuccess | getShippingProfilesV1ResponseError)

export const getGetShippingProfilesV1Url = () => {




  return `/api/v1/catalog/shipping/profiles`
}

/**
 * Returns the full shipping structure mirrored from Shopify: profiles (the store default
 * first) with their zones, covered countries (CountryCode "*" = rest-of-world catch-all)
 * and rates. This is the raw mirror — it includes inactive rates and carrier-calculated
 * ("DeliveryParticipant") rates that the resolve endpoint never offers. Rate prices are
 * in the store currency; a null price means carrier-calculated, not free.
 * @summary List shipping profiles
 */
export const getShippingProfilesV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getShippingProfilesV1Response> => {

  return customFetch<getShippingProfilesV1Response>(getGetShippingProfilesV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type resolveShippingRatesV1Response200 = {
  data: ShippingResolveResultDto
  status: 200
}

export type resolveShippingRatesV1Response400 = {
  data: void
  status: 400
}

export type resolveShippingRatesV1Response500 = {
  data: void
  status: 500
}

export type resolveShippingRatesV1ResponseSuccess = (resolveShippingRatesV1Response200) & {
  headers: Headers;
};
export type resolveShippingRatesV1ResponseError = (resolveShippingRatesV1Response400 | resolveShippingRatesV1Response500) & {
  headers: Headers;
};

export type resolveShippingRatesV1Response = (resolveShippingRatesV1ResponseSuccess | resolveShippingRatesV1ResponseError)

export const getResolveShippingRatesV1Url = (params: ResolveShippingRatesV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["products"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/catalog/shipping/resolve?${stringifiedParams}` : `/api/v1/catalog/shipping/resolve`
}

/**
 * Resolves the shipping options for a destination country and cart. Products (optional,
 * repeat the parameter per PublicGuid) are grouped by shipping profile — explicit
 * profile membership first, everything else under the store's default profile; with no
 * products the default profile alone is resolved. Custom profiles ABSORB the cart: when
 * any product belongs to a custom profile, only the custom profile group(s) are
 * returned — the default group is dropped and its products ship under the custom rate.
 * Each group gets the zone matching the country (exact match first, then the
 * rest-of-world catch-all) and the rates that are active, merchant-priced and whose
 * min/max price conditions pass against the subtotal (inclusive, all must pass; at an
 * exact boundary two rates can both apply — cheapest first). The client picks ONE rate
 * per group; total shipping is the sum of the picks.
 *
 * Notes:
 * - Shippable=false when any group has no applicable rate (one uncovered group blocks
 *   the whole cart, matching Shopify checkout).
 * - subtotal is interpreted in the store currency and applied to every group's
 *   conditions (per-profile subtotals are a future refinement).
 * - Weight-based conditions are not evaluated.
 * - Carrier-calculated rates ("DeliveryParticipant", e.g. third-party pickup apps) are
 *   never returned here — their price cannot be computed locally.
 * @summary Resolve applicable shipping rates
 */
export const resolveShippingRatesV1 = async (params: ResolveShippingRatesV1Params, options?: Parameters<typeof customFetch>[1]): Promise<resolveShippingRatesV1Response> => {

  return customFetch<resolveShippingRatesV1Response>(getResolveShippingRatesV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getStocksV1Response200 = {
  data: CpiStockDto[]
  status: 200
}

export type getStocksV1Response400 = {
  data: void
  status: 400
}

export type getStocksV1Response502 = {
  data: void
  status: 502
}

export type getStocksV1ResponseSuccess = (getStocksV1Response200) & {
  headers: Headers;
};
export type getStocksV1ResponseError = (getStocksV1Response400 | getStocksV1Response502) & {
  headers: Headers;
};

export type getStocksV1Response = (getStocksV1ResponseSuccess | getStocksV1ResponseError)

export const getGetStocksV1Url = (params: GetStocksV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/catalog/stocks?${stringifiedParams}` : `/api/v1/catalog/stocks`
}

/**
 * Returns stock levels aggregated across the warehouses that feed Shopify. Optionally filter by product detail code.
 * @summary Get stock levels from CPI
 */
export const getStocksV1 = async (params: GetStocksV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getStocksV1Response> => {

  return customFetch<getStocksV1Response>(getGetStocksV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


